import { LOCAL_STORAGE_KEY_JWT } from '@/api'
import Referral from '@/assets/icons/referral.svg?react'
import { routes } from '@/pages'
import { Button, Tooltip, TooltipContent, TooltipTrigger } from '@/ui-kit'
import { Link } from '@/ui-kit/components/Link'
import { useLocalStorage } from '@/utils/useLocalStorage'
import { Trans } from '@lingui/react/macro'
import clsx from 'clsx'
import { useLocation } from 'react-router-dom'
import { InviteReferralModal } from './InviteReferralModal'

export const InviteReferralButton = ({ collapseMobile }: { collapseMobile?: boolean }) => {
  const [jwt] = useLocalStorage(LOCAL_STORAGE_KEY_JWT, '')
  const { pathname, search } = useLocation()
  const returnTo = `${pathname}${search}`
  const loginUrl = `${routes.login.path}?redirect=${encodeURIComponent(returnTo)}`

  return jwt ? (
    <InviteReferralModal
      dialogTrigger={
        <Tooltip>
          <TooltipTrigger>
            <Button variant="tertiary" size="small">
              <span className="flex items-center gap-2">
                <Referral width={20} height={20} />
                <span className={clsx(collapseMobile && 'max-mobile:hidden')}>
                  <Trans>Get Referral Link</Trans>
                </span>
              </span>
            </Button>
          </TooltipTrigger>
          <TooltipContent
            align="end"
            className="flex max-w-[490px] gap-6 border border-solid !border-gray-100 !bg-[var(--colorBlackToWhite)] p-4 py-5"
          >
            <img src="/images/ref-tooltip.png" width={104} height={104} />
            <div className="text-[var(--colorWhiteToBlack)]">
              <Trans>
                When someone signs up using your referral link, they’ll receive a special welcome benefit, and you’ll
                earn exclusive rewards for each successful referral.
              </Trans>
            </div>
          </TooltipContent>
        </Tooltip>
      }
    />
  ) : (
    <Link href={loginUrl} variant="tertiary" size="small">
      <span className="flex items-center gap-2">
        <Referral width={20} height={20} />
        <span className={clsx(collapseMobile && 'max-mobile:hidden')}>
          <Trans>Get Referral Link</Trans>
        </span>
      </span>
    </Link>
  )
}
